export const checkoutFromSubmitButtonId = 'checkout-form-submit-button';
